<template>
  <div class="code-release-flow-detail">
    <Row :style="{marginBottom: '10px'}">
      <div :style="{float: 'left'}">
        <Button size="small" icon="ios-arrow-back" @click="$router.push({name: 'operateReleaseFlow', query: { page: $route.query.lastPage }})">返回列表</Button>
      </div>
    </Row>
    <Card shadow>
      <TestReport ref="TestReport" v-on:submitComplete="getData"></TestReport>
      <div class="content">
        <div class="main">
          <div>
            <Row style="margin-bottom: 10px" :gutter="16">
              <Col :xs="24" :sm="24" :md="24" :lg="19">
                <Row class="title">
                  <h4 :style="{float: 'left'}">运维流程申请工作流详情</h4>
                </Row>
                <Alert v-if="infoError" type="warning" show-icon>获取数据失败</Alert>
                <div class="info-property" v-else>
                  <dl>
                    <dt>申请人</dt><dd v-if="info.applicant">{{ info.applicant.name ?
                    info.applicant.name : info.applicant.username }}</dd>
                  </dl>
                  <dl>
                    <dt>标题</dt><dd>{{ info.title }}</dd>
                  </dl>
                  <!-- <dl>
                    <dt>发布模块</dt>
                    <dd>
                      <Tag v-for="item in info.module" :key="item.id">{{ item.name }}</Tag>
                      <Button type="warning" size="small" v-if="info.can_update_module" @click="openUpdateModuleModal" style="margin-left: 10px" ghost>修改</Button>
                    </dd>
                  </dl> -->
                  <!-- <dl>
                    <dt>版本号</dt><dd>{{ info.version }}</dd>
                  </dl> -->
                  <dl>
                    <dt>变更内容</dt>
                    <dd class="code-release-detail-describe"><span v-html="info.describe"></span></dd>
                  </dl>
                  <!-- <dl>
                    <dt>测试报告</dt>
                    <dd><a v-on:click="$refs.TestReport.openModal($route.params.id)">点击查看</a></dd>
                  </dl> -->
                  <dl>
                    <dt>测试报告附件</dt>
                    <dd>
                      <span v-if="info.enclosure">
                        <a v-if="info.enclosure.indexOf(',') === -1" download :href="operateReleaseFlowEnclosureBaseUrl + info.enclosure" target="_blank">{{ info.enclosure }} (点击下载)</a>
                        <span v-else>
                          <span v-for="(url, index) in info.enclosure.split(',')" :key="index">
                            &nbsp;
                            <a download :href="operateReleaseFlowEnclosureBaseUrl + url" target="_blank">{{ url }} (点击下载)</a>
                          </span>
                        </span>
                      </span>

                    </dd>
                  </dl>
                  <!-- <dl>
                    <dt>项目文档SVN地址</dt>
                    <dd>{{ info.test_report_address }}</dd>
                  </dl> -->
                  <!-- <dl>
                    <dt>文档和代码存放地址</dt>
                    <dd>{{ info.doc_code_address }}</dd>
                    <Button type="warning" size="small" @click="openCodeAddressModal" v-show="isCodeAddressEditShow">编辑</Button></dd>
                  </dl> -->
                  <dl>
                    <dt>优先级</dt>
                    <dd>{{ info.priority_verbose }}</dd>
                  </dl>
                  <dl>
                    <dt>变更类型</dt>
                    <dd>
                       {{ info.type_name }}
                    </dd>
                  </dl>
                  <dl v-if="info.created_at">
                    <dt>申请时间</dt><dd>{{ moment(info.created_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                  <!-- <dl v-if="info.status !== 0">
                    <dt>进度</dt>
                    <dd style="margin: 10px 0">
                      <Steps :current="info.status === 4 ? 0 : info.status === 5 ? 1 : 2" size="small">
                        <Step title="待审批"></Step>
                        <Step title="审批中"></Step>
                        <Step title="审批完成"></Step>
                      </Steps>
                    </dd>
                  </dl> -->
                  <dl style="margin-top: 15px">
                    <dt>操作</dt>
                    <dd>
                      <Approves :approves="info.approves" approveType="operate_release" :reFresh="this.handleReFresh" :status="info.status"/>
                    </dd>
                  </dl>
                </div>
                <!-- <Row className="margin-top-10">
                  <Row class="title">
                    <h4 :style="{float: 'left'}">代码发布申请工作流详情</h4>
                  </Row></Row> -->
                <!-- <Row className="margin-top-10">
                  <Row class="title">
                    <h4>构建任务</h4>
                  </Row>
                  <Row className="margin-top-10">
                    <Row class="title">
                      <h4>构建任务</h4>
                    </Row>
                    <BuildTasks ref="BuildTasks" :job-flow-id="$route.params.id"></BuildTasks>
                  </Row> -->
                </Col>
                <Col :md="{ span: 5, offset: 0 }">
                  <div class="title" >
                    <h4>日志信息</h4>
                  </div>
                  <FlowLogs :logs = "info.logs" />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Card>
    </Card>
  </div>
</template>

<script>
import moment from 'moment'
import { detailOperateReleaseFlow, operateReleaseFlowEnclosureBaseUrl } from '@/api/workflow/operate_release_flow'
import FlowLogs from '../components/Logs'
import Approves from '../components/Approves'
// import TestReport from './components/test-report'
import { getModuleAllList } from '@/api/workflow/project'
import { GetALLUsers } from '@/api/user'
// quill editor
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { VueEditor } from 'vue2-editor'
import { Treeselect, LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import * as cmdbRequestApi from '@/api/cmdb'

export default {
  components: {
    FlowLogs,
    Approves,
    // TestReport,
    VueEditor,
    Treeselect
  },
  data () {
    return {
      options: [],
      editorOption: {
        placeholder: '输入版本更新内容说明'
      },
      editorOptionBody: {
        placeholder: '输入邮件正文内容,例如 Deal ALL: xxx',
        modules: {
          toolbar: [['bold', 'italic']]
        }
      },
      notifyModal: false,
      appointModal: false,
      verifyModal: false,
      appointForm: {
        appoint_user: '',
        correct_remark: ''
      },
      verifyForm: {
        pm: ''
      },
      notifyForm: {
        notify_user: [],
        notify_user_tmp: [],
        guide_address: '',
        notify_version: '',
        notify_time: '',
        notify_cpjl: '',
        notify_xmjl: '',
        notify_csjl: '',
        notify_fbjl: '',
        notify_syyh: '',
        notify_content: '',
        notify_body: ''
      },
      all_user_list: [],
      all_email_list: [],
      isCodeAddressEditShow: false,
      editCodeAddressModal: false,
      // editCodeAddressForm: {
      //   doc_code_address: ''
      // },
      moment: moment,
      info: {},
      infoError: false,
      uploadHeader: {
        Authorization: 'OPS ' + this.$store.state.user.token,
        DefaultTenant: this.$store.state.user.defaultTenant,
        SelTenants: this.$store.state.user.selTenants
      },
      operateReleaseFlowEnclosureBaseUrl: operateReleaseFlowEnclosureBaseUrl,
      infoTimer: null,
      // 驳回
      refuseModal: false,
      refuseSubmitting: false,
      refuseContent: '',
      // 修改发布模块
      updateModuleSubmitting: false,
      updateModuleModal: false,
      updateModuleForm: {
        module: []
      },
      updateStatusForm: {
        status: null
      },
      updateModuleRules: {
        module: { required: true, type: 'array', message: '请至少选择一个模块' }
      },
      // validCodeAddress: {
      //   doc_code_address: { required: true, message: '文档代码存放地址不能为空', trigger: 'blur' }
      // },
      ruleValidateNotify: {
        // notify_user: { required: true, type: 'array', message: '请至少选择一个接收通知的用户', trigger: 'change' },
        notify_version: { required: true, message: '产品名称+版本号不能为空', trigger: 'blur' },
        notify_time: { required: true, message: '发布日期不能为空', trigger: 'blur' },
        notify_cpjl: { required: true, message: '产品经理不能为空', trigger: 'blur' },
        // notify_xmjl: { required: true, message: '项目经理不能为空', trigger: 'blur' },
        // notify_csjl: { required: true, message: '测试经理不能为空', trigger: 'blur' },
        // notify_fbjl: { required: true, message: '发布经理不能为空', trigger: 'blur' },
        notify_syyh: { required: true, message: '使用用户不能为空', trigger: 'blur' },
        notify_content: { required: true, message: '更新内容不能为空', trigger: 'blur' },
        notify_body: { required: true, message: '邮件正文不能为空', trigger: 'blur' }
      },
      moduleList: []
    }
  },
  created: function () {
    this.init()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.infoTimer)
    this.infoTimer = null
  },
  mounted: function () {
    // this.getOrg(1)
  },
  methods: {
    eventInput (value, instanceId) {
      console.log(value)
    },
    getOrg (id) {
      let params = {
        parentid: id
      }
      cmdbRequestApi.getWxOrgEmail(params).then(res => {
        console.log(res.data.result)
        if (id === 1) {
          this.options = res.data.result
        } else {
          return res.data.result
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取公司组织列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取公司组织列表失败！服务器无响应'
          })
        }
      })
    },
    loadOptions ({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        let params = {
          parentid: parentNode.id,
          get_people: 1
        }
        cmdbRequestApi.getWxOrgEmail(params).then(res => {
          parentNode.children = res.data.result
          callback()
        }).catch(res => {
          if (res.request) {
            this.$Notice.error({
              title: '获取公司组织列表失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '获取公司组织列表失败！服务器无响应'
            })
          }
        })
      }
    },
    notifyOk () {
      this.$refs['notifyForm'].validate((valid) => {
        if (valid) {
          console.log(this.notifyForm.notify_user_tmp instanceof Array)
          if (this.notifyForm.notify_user_tmp.length > 0 || this.notifyForm.notify_user.length > 0) {
            this.notifyForm.id = this.info.id
            this.notifyForm.notify_user_tmp = this.notifyForm.notify_user_tmp.map(item => item.id)
            notifyOkApi(this.info.id, this.notifyForm).then(res => {
              const result = res.data
              if (result.code === 200) {
                this.$Notice.success({
                  title: '操作成功！'
                })
                this.cancelNotifyModal()
                this.getData()
                this.notifyModal = false
              } else {
                this.$Notice.error({
                  title: '操作失败',
                  desc: result.msg
                })
              }
            }).catch(_ => {
            })
          } else {
            this.$Notice.error({
              title: '操作失败',
              desc: '请选择接收发布上线通知的用户'
            })
          }
        }
      })
    },
    // 发布上线通知
    notify () {
      this.notifyForm.notify_time = moment(new Date()).format('YYYY/MM/DD')
      this.notifyForm.notify_version = '傲基' + this.info.tenant_name + this.info.version + '版本'
      this.notifyForm.notify_cpjl = this.info.pm.name
      this.notifyForm.notify_content = this.info.describe
      this.notifyForm.notify_body = '<p><span style="color: rgb(0, 0, 0);">Dear&nbsp;all：</span></p><p><span style="color: rgb(0, 0, 0);">&nbsp;&nbsp;&nbsp;1、傲基' + this.info.tenant_name + '系统版本已更新至 ' + this.info.version + '，欢迎登录系统试用最新功能：</span><a href="http://www.aukeyit.com/" target="_blank" style="color: rgb(44, 74, 119); background-color: rgb(255, 255, 255);">www.aukeyit.com</a><span style="color: rgb(0, 0, 0);">。</span></p><p><span style="color: rgb(0, 0, 0);">&nbsp;&nbsp;&nbsp;2、如在使用系统过程中产生任何问题，可以通过企业微信工作台-信息部客服-帮助手册 快速获取常见问题解决方案；或选择 工单登记&nbsp;反馈问题。</span></p><p><span style="color: rgb(0, 0, 0);">&nbsp;&nbsp;&nbsp;3、本次更新的功能点如下：</span></p>'
      this.notifyForm.notify_syyh = this.info.tenant_name + '系统用户'
      this.notifyModal = true
    },
    // 获取所有客服列表
    getAllUsersData () {
      this.all_user_list = []
      GetALLUsers().then(res => {
        let result = res.data
        for (let i in result) {
          this.all_user_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    // 获取所有Email列表
    getAllEmailsData () {
      this.all_email_list = []
      GetALLEmails().then(res => {
        let result = res.data
        for (let i in result) {
          this.all_email_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    // openCodeAddressModal () {
    //   this.editCodeAddressForm.doc_code_address = this.info.doc_code_address
    //   this.editCodeAddressModal = true
    // },
    // cancelEditCodeAddressModal () {
    //   this.editCodeAddressModal.doc_code_address = ''
    // },
    editCodeAddressOK () {
      this.$refs['editCodeAddressForm'].validate((valid) => {
        console.log(valid)
        if (valid) {
          this.editCodeAddressForm.id = this.info.id
          editCodeAddressApi(this.editCodeAddressForm).then(res => {
            const result = res.data
            if (result.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.getData()
              this.editCodeAddressModal = false
              this.cancelEditCodeAddressModal()
            } else {
              this.$Notice.error({
                title: '操作失败',
                desc: result.msg
              })
            }
          }).catch(_ => {
          })
        }
      })
    },
    // 初始化
    init () {
      this.getData()
      // this.getAllUsersData()
      // this.getAllEmailsData()
      // this.setInfoTimer()
    },
    // 获取工作流信息
    getData () {
      detailOperateReleaseFlow(this.$route.params.id).then(res => {
        this.info = res.data
        this.isCodeAddressEditShow = this.info.approves.length > 0 ? this.info.approves[this.info.approves.length - 1].users.indexOf(this.$store.state.user.userName) > -1 : false
        this.infoError = false
      }).catch(res => {
        console.log(res.response)
        this.infoError = true
      })
    },
    // 处理刷新操作
    handleReFresh () {
      this.init()
    },
    // 上传测试报告附件成功
    uploadEnclosureSuccess (res, file) {
      this.$Notice.success({
        title: '上传成功'
      })
      this.getData()
    },
    // 上传测试报告附件失败
    uploadEnclosureError (err, msg) {
      this.$Notice.error({
        title: '上传失败',
        desc: msg
      })
      console.log(err)
    },
    // 上传测试报告格式不对
    uploadEnclosureFormatError () {
      this.$Notice.error({
        title: '只能上传格式为docx/xlsx/pdf的文件'
      })
    },
    // 上传测试报告超过限制大小
    uploadEnclosureExceededSize () {
      this.$Notice.error({
        title: '限制文件大小为10M'
      })
    },
    // 申请发布生产环境
    applyBuildProduct () {
      this.$Modal.confirm({
        title: '确认申请发布生产环境吗？',
        content: '确定后由运维人员进行构建生产环境',
        onOk: () => {
          applyoperateReleaseFlowBuildProduct(this.$route.params.id).then(res => {
            this.getData()
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(res => {
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 回滚生产环境
    rollbackProduct () {
      this.$Modal.confirm({
        title: '确认回滚生产环境吗？',
        content: '确定后由运维人员进行回滚生产环境',
        onOk: () => {
          applyoperateReleaseFlowRollback(this.$route.params.id).then(res => {
            this.getData()
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(res => {
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 测试进行线上验证未通过
    verifyOnlineError () {
      this.$Modal.confirm({
        title: '确认线上生产环境验证不通过吗？',
        content: '确定后由运维人员决定是否要进行回滚生产环境',
        onOk: () => {
          this.updateStatusForm = {
            status: 31
          }
          updateoperateReleaseFlowStatus(this.$route.params.id, this.updateStatusForm).then(res => {
            this.getData()
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(res => {
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 测试进行线上验证通过
    verifyOnlineSuccess () {
      if (this.info.logs.filter(item => item.content.indexOf('回滚生产环境') > -1).length > 0) {
        this.verify_rollback_ok()
      } else {
        // this.verifyModal = true
        this.verifyOk()
      }
    },
    // 测试进行线上验证未通过
    verify_rollback_ok () {
      this.$Modal.confirm({
        title: '确认回滚后的生产环境验证通过吗？',
        content: '确定后此次发布流程全部结束',
        onOk: () => {
          this.updateStatusForm = {
            status: 50
          }
          updateoperateReleaseFlowStatus(this.$route.params.id, this.updateStatusForm).then(res => {
            this.getData()
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(res => {
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 测试进行线上验证未通过
    correct_ok () {
      this.$Modal.confirm({
        title: '确认已经整改完毕吗？',
        content: '确定后此次发布流程全部结束',
        onOk: () => {
          this.updateStatusForm = {
            status: 34
          }
          updateoperateReleaseFlowStatus(this.$route.params.id, this.updateStatusForm).then(res => {
            this.getData()
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(res => {
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    // 维护组验收未通过
    acceptSuccess () {
      this.$Modal.confirm({
        title: '确认线上生产环境验收通过吗？',
        content: '请详细检查相关资料是否齐全,确定后此次发布流程全部结束',
        onOk: () => {
          this.updateStatusForm = {
            status: 32
          }
          updateoperateReleaseFlowStatus(this.$route.params.id, this.updateStatusForm).then(res => {
            this.getData()
            this.$Notice.success({
              title: '操作成功！'
            })
          }).catch(res => {
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    cancelNotifyModal () {
      this.notifyForm = {
        notify_user: '',
        guide_address: ''
      }
    },
    cancelModal () {
      this.appointForm = {
        appoint_user: '',
        correct_remark: ''
      }
    },
    cancelVerifyModal () {
      this.verifyForm = {
        pm: ''
      }
    },
    appointOk () {
      this.$refs['appointForm'].validate((valid) => {
        if (valid) {
          this.appointForm.id = this.info.id
          if (this.appointForm.appoint_user) {
            appointApi(this.info.id, this.appointForm).then(res => {
              const result = res.data
              if (result.code === 200) {
                this.$Notice.success({
                  title: '操作成功！'
                })
                this.cancelModal()
                this.getData()
                this.appointModal = false
              } else {
                this.$Notice.error({
                  title: '操作失败',
                  desc: result.msg
                })
              }
            }).catch(_ => {
            })
          } else {
            this.$Notice.error({
              title: '操作失败',
              desc: '请填指派用户'
            })
          }
        }
      })
    },
    verifyOk () {
      verifyOkApi(this.info.id, this.verifyForm).then(res => {
        const result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '操作成功！'
          })
          this.cancelVerifyModal()
          this.getData()
          this.verifyModal = false
        } else {
          this.$Notice.error({
            title: '操作失败',
            desc: result.msg
          })
        }
      }).catch(_ => {
      })
    },
    // 维护组验收不通过
    acceptError () {
      this.appointModal = true
    },
    // setInfoTimer () {
    //   clearInterval(this.infoTimer)
    //   this.infoTimer = null
    //   if (this.infoTimer == null) {
    //     this.infoTimer = setInterval(() => {
    //       this.getData()
    //     }, 5000)
    //   }
    // },
    // 驳回
    refuse () {
      this.refuseSubmitting = true
      refuseoperateReleaseFlowBuildTask(this.$route.params.id, this.refuseContent).then(res => {
        this.getData()
        this.$Notice.success({
          title: '操作成功！'
        })
        this.refuseSubmitting = false
        this.refuseModal = false
      }).catch(res => {
        this.refuseSubmitting = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    openUpdateModuleModal () {
      this.updateModuleForm.module = this.info.module.map(item => item.id)
      this.getModuleList()
      this.updateModuleModal = true
    },
    // 获取模块列表
    getModuleList () {
      getModuleAllList({ tenant_id__in: this.info.tenant_id }).then(res => {
        this.moduleList = res.data
      })
    },
    // 修改发布模块
    updateModuleSubmit () {
      this.$refs.updateModuleForm.validate((valid) => {
        if (valid) {
          this.updateModuleSubmitting = true
          updateModuleoperateReleaseFlow(this.$route.params.id, this.updateModuleForm).then(res => {
            this.$Notice.success({ title: '操作成功' })
            this.updateModuleModal = false
            this.updateModuleSubmitting = false
            this.getData()
          }).catch(res => {
            this.updateModuleSubmitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .code-release-detail-describe {
    padding: 0;
    overflow-y: auto;
    max-height: 350px;
    padding-bottom: 5px;
    margin-top: 5px;
  }
  .code-release-detail-describe::-webkit-scrollbar {
    width: 5px;
  }
  .code-release-detail-describe::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .code-release-detail-describe::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
  .code-release-notify-content {
    .ivu-form-item-content {
      line-height: unset !important;
    }
    .ql-snow.ql-toolbar {
      padding-top: unset !important;
      padding-bottom: unset !important;
    }
    .ql-toolbar.ql-snow {
      padding: unset;
    }
    .ql-formats {
      margin-top: 3px;
      margin-bottom: unset !important;
      button svg {
        width: unset !important;
        height: unset !important;
      }
    }
  }
  .code-release-notify-email {
    .ql-toolbar {
      display: none;
    }
    .ql-container {
      border-radius: 4px;
      border-top: 1px solid #ccc !important;
    }
  }
</style>
